// Lib
import React, { Children, cloneElement } from 'react';
import styled from 'styled-components';

// Theme
import colors from 'theme/colors';

// Hooks
import useDropDownHandlers from 'hooks/useDropDownHandlers';

// Components
import ClickOutside from '../ClickOutside';
import DropDownItem from './DropDownItem';
import SelectDropDownItem from './SelectDropDownItem';

const DropDownContent = styled.div<any>`
  background: ${colors.white};
  border: 2px solid ${colors.gray};
  display: ${props => (props.visible ? 'block' : 'flex')};
  visibility: ${props => (props.visible ? 'inherit' : 'hidden')};
  margin-left: ${props => !props.isLeftSide && '5px'};
  margin-top: 5px;
  min-width: ${props => props.minWidth};
  position: absolute;
  ${props => props.isLeftSide && { marginRight: 5, right: '100%' }}
`;

interface DropDownProps {
  visible: boolean;
  children: any;
  onClose: VoidFunction;
  isLeftSide?: boolean;
  minWidth?: string;
  contentStyle?: any;
}

const DropDown: React.FC<DropDownProps> = (props): JSX.Element => {
  const { visible, children, onClose, isLeftSide, minWidth, contentStyle } = props;
  const { node, isCloseToBottom } = useDropDownHandlers();

  return (
    <ClickOutside onClickOutside={onClose}>
      <DropDownContent
        visible={visible}
        isLeftSide={isLeftSide}
        minWidth={minWidth}
        ref={node}
        isBottom={isCloseToBottom}
        style={contentStyle}
      >
        {Children.toArray(children).map(item => cloneElement(item, { isLeftSide }))}
      </DropDownContent>
    </ClickOutside>
  );
};

DropDown.defaultProps = {
  isLeftSide: false,
  minWidth: '175px',
  contentStyle: {},
};

export { DropDownItem, SelectDropDownItem };
export default DropDown;
